<template>
  <div>
    <div class="form-group" v-bind:class="{'has-error': fieldErrors('year')}">
      <label for="year">* Year</label>
      <input @input="updateVehicleFormField" :value="vehicle.year" id="year" name="year" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('year')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('make')}">
      <label for="make">* Make</label>
      <input @input="updateVehicleFormField" :value="vehicle.make" id="make" name="make" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('make')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('model')}">
      <label for="model">* Model</label>
      <input @input="updateVehicleFormField" :value="vehicle.model" id="model" name="model" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('model')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('vin')}">
      <label for="vin">* Vehicle ID</label>
      <input @input="updateVehicleFormField" :value="vehicle.vin" id="vin" name="vin" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('vin')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('licensePlate')}">
      <label for="licensePlate">* License Plate</label>
      <input @input="updateVehicleFormField" :value="vehicle.licensePlate" id="licensePlate" name="licensePlate" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('licensePlate')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('licenseState')}">
      <label for="licenseState">* License Plate State / Province</label>
      <select @input="updateVehicleFormField" :value="vehicle.licenseState" id="licenseState" name="licenseState" class="form-control">
        <!-- <option value="">Please Select</option> -->
        <optgroup v-for="optgroup in stateOptions" :label="optgroup.label" :key="optgroup.label">
          <option v-for="(label,value) in optgroup.options" :value="value" :key="value">
            {{ label }}
          </option>
        </optgroup>
      </select>
      <error-list v-bind:errors="fieldErrors('licenseState')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('insuranceCompany')}">
      <label for="insuranceCompany">Insurance Company</label>
      <input @input="updateVehicleFormField" :value="vehicle.insuranceCompany" id="insuranceCompany" name="insuranceCompany" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('insuranceCompany')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('lienholder')}">
      <label for="lienholder">Lienholder</label>
      <input @input="updateVehicleFormField" :value="vehicle.lienholder" id="lienholder" name="lienholder" type="text" class="form-control">
      <error-list v-bind:errors="fieldErrors('lienholder')" />
     </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('motorhomeLength')}">
      <label for="motorhomeLength">Motohome Length (ft)</label>
      <input @input="updateVehicleFormField" :value="vehicle.motorhomeLength" id="motorhomeLength" name="motorhomeLength" type="number" class="form-control">
      <error-list v-bind:errors="fieldErrors('motorhomeLength')" />
    </div>

    <div class="form-group" v-bind:class="{'has-error': fieldErrors('cmv')}">
      <label for="cmv">* Current Market Value (usd)</label>
      <div class="input-group">
        <span class="input-group-addon">$</span>
        <input @input="updateVehicleFormField" :value="vehicle.cmv" id="cmv" name="cmv" type="number" class="form-control">
      </div>
      <error-list v-bind:errors="fieldErrors('cmv')" />
    </div>

    <div class="form-group">
      <label>Towed Units?</label>

      <div class="tow-options">
        <div class="radio-inline">
          <label for="towed-yes" class="control-label">
            <input id="towed-yes" name="has_towed[]" type="radio" :checked="isTowing" @change="initTow">
            Yes
          </label>
        </div>

        <div class="radio-inline">
          <label for="towed-no" class="control-lable">
            <input id="towed-no" name="has_towed[]" type="radio" :checked="!isTowing" @change="clearTow">
            No
          </label>
        </div>
      </div>
    </div>

    <towed-unit-fields
      v-for="(towedUnit, idx) in towedUnits"
      :towedUnit="towedUnit"
      :state-options="stateOptions"
      :key="idx"
      :index="idx"
      @updateTowedUnit="towedUnitUpdated"
      @removeTow="removeTow"
    />

    <button
      v-if="towedUnits.length"
      class="btn btn-default"
      type="button"
      @click="addTow"
    >
        Additional Towed Unit
    </button>

  </div>
</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex'
import ErrorList from "./ErrorList.vue"
import TowedUnitFields from "./TowedUnitFields.vue"


export default {
  name: 'VehicleForm',
  components: {
    ErrorList,
    TowedUnitFields,
  },
  props: [
  ],
  data: function() {
    return {}
  },
  computed: {
    ...mapState([
      'stateOptions',
      'vehicle',
      'vehicleErrors',
      'towedUnits',
    ]),
    ...mapGetters([
      'isTowing',
    ]),
  },
  methods: {
    ...mapActions([
      'updateVehicleField',
      'addTowedUnit',
      'clearTowedUnits',
    ]),
    updateVehicleFormField: function(e) {
      let payload = {
        fieldkey: e.target.name,
        val: e.target.value,
      }
      this.updateVehicleField(payload)
    },
    fieldErrors: function(fieldId) {
      let formErrors = this.vehicleErrors
      if (!formErrors) {
        return false;
      }
      if (!formErrors.hasOwnProperty(fieldId)) {
        return false
      }
      return formErrors[fieldId]
    },
    initTow: function() {
      if (!this.towedUnits.length) {
        this.addTowedUnit()
      }
    },
    clearTow: function()  {
      if (this.towedUnits.length) {
        this.clearTowedUnits()
      }
    },
    addTow: function() {
      this.addTowedUnit()
    },
    removeTow: function(towIndex) {
      let newTowedUnits = this.towedUnits.filter((x, idx) => idx != towIndex)
      this.$emit('updateTowedUnits', newTowedUnits)
    },
    towedUnitUpdated: function([unitIndex, newValue]) {
      let newTowedUnits = this.towedUnits.map((x, idx) => {
        if (idx == unitIndex) { return newValue } else return x
      })
      this.$emit('updateTowedUnits', newTowedUnits)
    },
  },
}
</script>

<style>
.tow-options label {
  font-weight: normal;
}
</style>
